<template>
    <v-card class="elevation-10">
        <v-card-title>
            <CrearOfertaModal @created="crearOferta"></CrearOfertaModal>
                <ImportModalComponent @importado="getItems"></ImportModalComponent>
                <v-btn color="primary" :href="API_BASE + 'offers/template?download_token='+ token" target="_blank">Download template</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" :href="API_BASE + 'offers/export?download_token='+ token" target="_blank">Export</v-btn>
                <!--<v-btn color="red" @click="deleteAll()">Delete all offers</v-btn>-->
        </v-card-title>
        <v-card-title>
            <v-flex xs2>
                <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                >
                    <template slot="activator">
                        <v-text-field
                                v-model="start_date"
                                label="Start date"
                                prepend-icon="event"
                                readonly
                                clearable
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="start_date" @input="menu2 = false"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs2>
                <v-menu
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                >
                    <template slot="activator">
                        <v-text-field
                                v-model="end_date"
                                label="End date"
                                prepend-icon="event"
                                readonly
                                clearable
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="end_date" @input="menu3 = false"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs1 d-flex>
                <v-select
                        :items="vistas"
                        label="Vista"
                        v-model="vista"
                ></v-select>
            </v-flex>
            <v-flex xs1 d-flex class="ml-4">
                <v-select
                        :items="pages"
                        label="Per page"
                        v-model="per_page"
                        @change="getItems"
                ></v-select>
            </v-flex>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="items.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="headers" slot-scope="props">
                <tr>
                    <th style="padding: 0px">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="commercials"
                                            color="primary"
                                            item-text="name"
                                            label="Commercial"
                                            v-model="search_commercial"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Commercial
                        <v-btn flat icon small color="primary" @click="ordenar('commercial')">
                            <v-icon v-if="col == 'commercial' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'commercial' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'commercial'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="companies"
                                            color="primary"
                                            item-text="name"
                                            label="Company"
                                            v-model="search_company"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Company
                        <v-btn flat icon small color="primary" @click="ordenar('company')">
                            <v-icon v-if="col == 'company' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'company' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'company'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px">
                                    <v-autocomplete
                                            :items="countries"
                                            color="primary"
                                            item-text="name"
                                            label="Country"
                                            v-model="search_country"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Country
                        <v-btn flat icon small color="primary" @click="ordenar('country')">
                            <v-icon v-if="col == 'country' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'country' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'country'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-menu
                                            v-model="menu4"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <template slot="activator">
                                            <v-text-field
                                                    v-model="search_date"
                                                    label="Date"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="search_date" @input="menu4 = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Date
                        <v-btn flat icon small color="primary" @click="ordenar('date')">
                            <v-icon v-if="col == 'date' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'date' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'date'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-text-field
                                            v-model="search_email"
                                            label="Email"
                                    ></v-text-field>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Email
                        <v-btn flat icon small color="primary" @click="ordenar('email')">
                            <v-icon v-if="col == 'email' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'email' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'email'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="final_clients"
                                            color="primary"
                                            item-text="name"
                                            label="Final client"
                                            v-model="search_final_client"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Final client
                        <v-btn flat icon small color="primary" @click="ordenar('final_client')">
                            <v-icon v-if="col == 'final_client' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'final_client' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'final_client'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px" v-if="vista == 'detalle'">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="fruits"
                                            color="primary"
                                            item-text="name"
                                            label="Fruit"
                                            v-model="search_fruit"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Fruit
                        <v-btn flat icon small color="primary" @click="ordenar('fruit')">
                            <v-icon v-if="col == 'fruit' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'fruit' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'fruit'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px" v-if="vista == 'detalle'">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="offers"
                                            color="primary"
                                            item-text="name"
                                            label="Offer"
                                            v-model="search_offer"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Offer
                        <v-btn flat icon small color="primary" @click="ordenar('offer')">
                            <v-icon v-if="col == 'offer' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'offer' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'offer'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px" v-if="vista == 'detalle'">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="product_codes"
                                            color="primary"
                                            item-text="name"
                                            label="Product code"
                                            v-model="search_product_code"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Product code
                        <v-btn flat icon small color="primary" @click="ordenar('product_code')">
                            <v-icon v-if="col == 'product_code' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'product_code' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'product_code'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px" v-if="vista == 'detalle'">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="products"
                                            color="primary"
                                            item-text="name"
                                            label="Products"
                                            v-model="search_products"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        products
                        <v-btn flat icon small color="primary" @click="ordenar('products')">
                            <v-icon v-if="col == 'products' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'products' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'products'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th style="padding: 0px" v-if="vista == 'detalle'">
                        <v-menu
                                bottom
                                left
                                offset-y
                                :close-on-content-click="false"
                                style="width: 35px;"
                        >
                            <v-btn flat icon small color="primary" slot="activator">
                                <v-icon small>search</v-icon>
                            </v-btn>
                            <v-card>
                                <v-flex style="padding: 10px;">
                                    <v-autocomplete
                                            :items="product_codes"
                                            color="primary"
                                            item-text="name"
                                            label="Product code"
                                            v-model="search_product_code"
                                            @change="debouncedGetItems"
                                            :auto-select-first="true"
                                            persistent-hint
                                            :hide-selected="true"
                                            clearable
                                    ></v-autocomplete>
                                </v-flex>
                            </v-card>
                        </v-menu>
                        Final Cliente/Country
                        <v-btn flat icon small color="primary" @click="ordenar('final_client_country')">
                            <v-icon v-if="col == 'final_client_country' && order == 'desc'" small>arrow_downward</v-icon>
                            <v-icon v-if="col == 'final_client_country' && order == 'asc'" small>arrow_upward</v-icon>
                            <v-icon v-if="col != 'final_client_country'" small>sort</v-icon>
                        </v-btn>
                    </th>
                    <th>Actions</th>
                </tr>
            </template>
            <template slot="items" slot-scope="props">
                <td style="padding: 10px" class="text-xs">{{ props.item.commercial }}</td>
                <td style="padding: 10px" class="text-xs">{{ props.item.company }}</td>
                <td style="padding: 10px" class="text-xs">{{ props.item.country }}</td>
                <td style="padding: 10px" class="text-xs">{{ props.item.date }}</td>
                <td style="padding: 10px" class="text-xs">{{ props.item.email }}</td>
                <td style="padding: 10px" class="text-xs" v-if="vista == 'detalle'">{{ props.item.final_client }}</td>
                <td style="padding: 10px" class="text-xs" v-if="vista == 'detalle'">{{ props.item.fruit }}</td>
                <td style="padding: 10px" class="text-xs" v-if="vista == 'detalle'">{{ props.item.offer }}</td>
                <td style="padding: 10px" class="text-xs" v-if="vista == 'detalle'">{{ props.item.product_code }}</td>
                <td style="padding: 10px" class="text-xs" v-if="vista == 'detalle'">{{ props.item.products }}</td>
                <td style="padding: 10px" class="text-xs" v-if="vista == 'detalle'">{{ props.item.final_client_country }}</td>
                <td style="padding: 10px" class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <EditOfertaModal :offer="props.item" @editado="editar"></EditOfertaModal>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="items.data">
            <v-pagination
                    v-model="page"
                    :length="items.meta.last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ items.meta.from }} to {{ items.meta.to }} of {{ items.meta.total }} entries</p>
        </div>
    </v-card>
</template>

<script>
    import ImportModalComponent from './components/ImportModalComponent';
    import { API_BASE } from '../../config';
    import CrearOfertaModal from './components/CrearOfertaModal';
    import EditOfertaModal from './components/EditOfertaModal';

    export default {
        data () {
            return {
                search: null,
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                pages: ['10', '15', '20', '30', '60', '100'],
                headers: [
                    { text: 'Commercial', align: 'left', value: 'commercial', sortable: false },
                    {
                        text: 'Company',
                        sortable: false,
                        value: 'company'
                    },
                    { text: 'Country', value: 'country', sortable: false },
                    { text: 'Date', value: 'date', sortable: false },
                    { text: 'Email', value: 'email', sortable: false },
                    { text: 'Final client', value: 'final_client', sortable: false },
                    { text: 'Fruit', value: 'fruit', sortable: false },
                    { text: 'Offer', value: 'offer', sortable: false },
                    { text: 'Product code', value: 'product_code', sortable: false },
                    { text: 'Products', value: 'products', sortable: false },
                    { text: 'Final Cliente/Country', value: 'final_client_country', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                items: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                search_commercial: '',
                search_company : '',
                search_country : '',
                search_date : '',
                search_email : '',
                search_final_client : '',
                search_fruit : '',
                search_offer : '',
                search_product_code : '',
                search_products : '',
                token: null,
                API_BASE: API_BASE,
                per_page: "20",
                col: 'date',
                order: 'desc',
                countries: null,
                commercials: null,
                companies: null,
                emails: null,
                final_clients: null,
                fruits: null,
                offers: null,
                product_codes: null,
                products: null,
                start_date: null,
                end_date: null,
                menu2: false,
                menu3: false,
                menu4: false,
                vistas: ['detalle', 'ligera'],
                vista: 'detalle'
            }
        },
        created: function() {
            this.checkUser();
            this.setSectionTitle();
            this.getItems();
            this.getSelects('commercial');
            this.getSelects('company');
            this.getSelects('country');
            this.getSelects('email');
            this.getSelects('final_client');
            this.getSelects('fruit');
            this.getSelects('offer');
            this.getSelects('product_code');
            this.getSelects('products');
            this.debouncedGetItems = _.debounce(this.getItems, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetItems();
            },
            last_page: function () {
                if (this.page > this.items.meta.last_page) {
                    this.page = 1;
                }
            },
            search_date: function () {
                this.debouncedGetItems();
            },
            start_date: function () {
                this.debouncedGetItems();
            },
            end_date: function () {
                this.debouncedGetItems();
            },
            search_email: function () {
                this.debouncedGetItems();
            },
        },
        methods : {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Offers list.'
                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteOffer', {
                            id: id
                        }).then((res) => {

                            this.getItems();

                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getItems();
            },
            getItems () {
                this.loading = true;
                var params = {
                    filters : {
                        start_date: this.start_date ? this.start_date : '',
                        end_date: this.end_date ? this.end_date : '',
                        col: this.col,
                        order: this.order,
                        page: this.page,
                        per_page: this.per_page,
                        'search-commercial': this.search_commercial == undefined ? '' : this.search_commercial,
                        'search-company' : this.search_company == undefined ? '' : this.search_company,
                        'search-country' : this.search_country == undefined ? '' : this.search_country,
                        'search-date' : this.search_date == undefined ? '' : this.search_date,
                        'search-email' : this.search_email == undefined ? '' : this.search_email,
                        'search-final_client' : this.search_final_client == undefined ? '' : this.search_final_client,
                        'search-fruit' : this.search_fruit == undefined ? '' : this.search_fruit,
                        'search-offer' : this.search_offer == undefined ? '' : this.search_offer,
                        'search-product_code' : this.search_product_code == undefined ? '' : this.search_product_code,
                        'search-products' : this.search_products == undefined ? '' : this.search_products,
                    }
                };
                this.$store.dispatch('getOffers', params).then((res) => {
                    this.items = res.data;
                    this.loading = false;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                }).catch((error) => {

                });
            },
            crearOferta(oferta) {
                this.$store.dispatch('addOffer', oferta).then((res) => {
                    this.getItems();
                }).catch((error) => {

                });
            },
            editar(oferta) {
                this.$store.dispatch('editOffer', oferta).then((res) => {
                    this.getItems();
                }).catch((error) => {

                });
            },
            close () {
                console.log('Dialog closed')
            },
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            deleteAll() {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteAllOffers').then((res) => {

                            this.getItems();

                        }).catch((error) => {

                        });
                    }
                });
            },
            ordenar (column) {
                if (column == this.col) {
                    if (this.order == 'desc') {
                        this.order = 'asc';
                    } else {
                        this.order = 'desc'
                    }
                } else {
                    this.col = column;
                    this.order = 'desc'
                }

                this.getItems();
            },
            getSelects(column) {
                var params = {
                    filters : {
                        column: column,
                    }
                };
                this.$store.dispatch('getOfferCountries', params).then((res) => {
                    if (column == 'country') {
                        this.countries = res.data.data;
                    }
                    if (column == 'commercial') {
                        this.commercials = res.data.data;
                    }
                    if (column == 'company') {
                        this.companies = res.data.data;
                    }
                    if (column == 'email') {
                        this.emails = res.data.data;
                    }
                    if (column == 'final_client') {
                        this.final_clients = res.data.data;
                    }
                    if (column == 'fruit') {
                        this.fruits = res.data.data;
                    }
                    if (column == 'offer') {
                        this.offers = res.data.data;
                    }
                    if (column == 'product_code') {
                        this.product_codes = res.data.data;
                    }
                    if (column == 'products') {
                        this.products = res.data.data;
                    }

                }).catch((error) => {

                });
            }
        },
        components: {
            ImportModalComponent,
            CrearOfertaModal,
            EditOfertaModal
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/oferta/IndexComponent.vue